// ============================================================
// ANSICHTSSACHE-AGENT – Das Befundband
// ============================================================
// Das Ergebnis eines Laufs in einer Zeile: gut, schlecht, oder
// „noch nichts geprueft". Drei Zustaende und nicht zwei — ein
// Lauf, der nie stattgefunden hat, ist weder gruen noch rot, und
// ihn als eines von beiden zu zeichnen waere eine Auskunft, die
// niemand gegeben hat.
//
// Entstanden in der Compliance und von dort herausgezogen, als
// die Buchhaltung dasselbe brauchte. Eine zweite Fassung waere
// schon beim naechsten Ton auseinandergelaufen.
//
// VIER Zustaende seit der USt-IdNr.-Pruefung (22.09.2026): eine
// Bestaetigung, die ein halbes Jahr alt ist, ist nicht ROT — die
// Nummer war gueltig, der Nachweis ist nur nicht mehr frisch. Wer
// so etwas als Fehler zeichnet, hat beim naechsten echten Fehler
// keine Farbe mehr uebrig.
// ============================================================

import { CheckCircle2, ShieldAlert, TriangleAlert, XCircle } from "lucide-react";
import { cn } from "@/lib/utils";

export type Befundzustand = "gut" | "schlecht" | "warnung" | "offen";

export function Befundband({
  zustand,
  titel,
  text,
  className,
}: {
  zustand: Befundzustand;
  titel: string;
  text: React.ReactNode;
  className?: string;
}) {
  const Icon =
    zustand === "offen"
      ? ShieldAlert
      : zustand === "gut"
        ? CheckCircle2
        : zustand === "warnung"
          ? TriangleAlert
          : XCircle;

  return (
    <div
      className={cn(
        "flex items-start gap-2.5 rounded-xl border px-4 py-3",
        zustand === "offen"
          ? "border-border bg-bg-secondary text-text-secondary"
          : zustand === "gut"
            ? "border-success/25 bg-success-subtle text-success"
            : zustand === "warnung"
              ? "border-warning/25 bg-warning-subtle text-warning"
              : "border-danger/25 bg-danger-subtle text-danger",
        className,
      )}
    >
      <Icon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
      <div className="min-w-0">
        <p className="text-body-sm font-medium">{titel}</p>
        <p className="text-caption mt-0.5 opacity-90">{text}</p>
      </div>
    </div>
  );
}
